import { Card, Grid } from "@aws-amplify/ui-react";
import { Box, CardContent, Skeleton, styled } from "@mui/material";

const NumberBox = styled(Box)(({ theme }) => ({
  width: theme.spacing(10),
  backgroundColor: "#1AA39B",
  color: "white",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "3rem",
}));

export const SkeletonComponent = ({ max }) => {
  const array = Array.from({ length: max }, (_, i) => i + 1);
  return (
    <Grid container spacing={2}>
      {[...Array(3)].map((_, index) => (
        <Grid item xs={12} key={index}>
          <Card
            sx={{
              display: "flex",
              m: 2,
              width: "98%",
              border: 1,
              borderColor: "divider",
              borderRadius: 2,
            }}
          >
            <NumberBox />
            <CardContent sx={{ width: "100%" }}>
              {array.map((item) => (
                <Skeleton
                  key={item}
                  sx={{ width: `${item * 10}%` }}
                  variant="text"
                />
              ))}
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};
